<template>
  <div v-if="showForm">
    <v-toolbar
      elevation="0"     
    >
      <v-icon large style="margin-right:10px;">mdi-file-multiple</v-icon>
      <v-toolbar-title>
        {{ $t('common.workspace', locale) }}
      </v-toolbar-title>
    </v-toolbar>
    <v-progress-linear indeterminate v-if="loading" />
    <v-container v-else-if="editedItem">
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-bind="{ 'outlined' : true}"
                v-model="editedItem.Name"
                :label="$t('sysUser.name', locale)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <color-picker-primary-secondary
                style="width: 100px;"
                :primaryColor="editedItem.PrimaryColor"
                :secondaryColor="editedItem.SecondaryColor"
                :onChangeColor="handleChangeColors"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <v-text-field
                v-bind="{ 'outlined' : true}"
                v-model="editedItem.RenameFolders"
                :label="$t('workspace.renameFolders', locale)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <!--select-sys-users
                area="dfiles"
                :workspaceID="editedItem.ID"
                :onChangeUser="handleChangeUser"
              /-->
              <select-sys-users-permissions
                area="dfiles"
                :workspaceID="editedItem.ID"
                :onChangeUser="handleChangeUser"
              />
            </v-col>
          </v-row>
    </v-container>
    <action-buttons
      v-if="editedItem"
      :id="editedItem.ID"
      :onDeleteItem="handleDelete"
      :onSaveItem="handleSave"
      :onClose="onClose"
      :locale="locale"
    />
  </div>
</template>
<script>
  const defaultItem = {
    Name: '',
    Users: [],
  }
  
  import { mapState } from 'vuex'
  import api from '@/services/api'
  //import SelectSysUsers from '@/components/SelectSysUsers'
  import SelectSysUsersPermissions from '@/components/SelectSysUsersPermissions'
  import ActionButtons from '@/components/ActionButtons'
  import ColorPickerPrimarySecondary from '@/components/ColorPickerPrimarySecondary'
  export default{
    name: 'WorkspaceForm',
    components: {
      ActionButtons,
      //SelectSysUsers,
      SelectSysUsersPermissions,
      ColorPickerPrimarySecondary,
    },
    props: {
      editedID: {
        type: String,
        default: null
      },
      showForm: {
        type: Boolean,
        default: false
      },
      onDelete: {
        type: Function,
        required: true
      },
      onSave: {
        type: Function,
        required: true
      },
      onClose: {
        type: Function,
        required: true
      },
    },
    data () {
      return {
        loading: false,
        editedItem: null
      }
    },
    computed: {
      ...mapState('app',['locale']),
    },
    watch: {
      showForm (v) {
        if (v) {
          if(this.editedID) this.handleGetData()
          else this.editedItem = defaultItem
        }
      },
      editedID (v) {
        if (this.showForm) {
          if (v) this.handleGetData()
          else this.editedItem = defaultItem

        }
      },
    },
    methods: {
      handleGetData () {
        this.loading = true
        api.getItem ('dfiles', 'v1/system/workspaces/', this.editedID)
        .then(response => {   
          this.editedItem = response
          this.loading = false
        })
 
      },
      handleChangeUser (v) {
        this.editedItem.Users = v
      },
      handleChangeColors (primaryColor, secondaryColor) {
        this.editedItem.PrimaryColor = primaryColor ? primaryColor : null
        this.editedItem.SecondaryColor = secondaryColor ? secondaryColor : null
      },
      handleSave () {
        this.onSave(this.editedItem)
      },
      handleDelete () {
        this.onDelete(this.editedItem.ID)
      }
    }
  }
</script>
